/**
 * Determine if the passed line is the main line
 */
export function isMainLine(line: number): boolean {
  return line === 0;
}
